import EDCPage from "./index.js";
import EDCManagementDashboardPage from "./management/index.js";
import EDCAreasPage from "./management/areas/index.js";
import EDCFeedersPage from "./management/feeders/index.js";
import EDCLVTransPage from "./management/lv-trans/index.js";
import EDCSubstationsPage from "./management/substations/index.js";
import EDCUsersPage from "./management/users/index.js";
import DistributionRequestsPage from "./requests/DistributionRequestsPage.js";
import DistributionUnitDashboardPage from "./requests/DistributionUnitDashboardPage.js";
import { REQUEST_UNITS, REQUEST_VIEWS } from "./edcPaths";

const requestRoutes = (unitKey) => [
  { path: "", element: <DistributionUnitDashboardPage key={`${unitKey}-dashboard`} unitKey={unitKey} /> },
  ...REQUEST_VIEWS.map((view) => ({
    path: view.key,
    element: <DistributionRequestsPage key={`${unitKey}-${view.key}`} unitKey={unitKey} viewKey={view.key} />,
  })),
];

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  path: "EDC",
  children: [
    { path: "", element: <EDCPage /> },
    {
      path: "Management",
      children: [
        { path: "", element: <EDCManagementDashboardPage /> },
        { path: "Areas", element: <EDCAreasPage /> },
        { path: "SubstationInformation", element: <EDCSubstationsPage /> },
        { path: "FeederInformation", element: <EDCFeedersPage /> },
        { path: "LVTrans", element: <EDCLVTransPage /> },
        { path: "Users", element: <EDCUsersPage /> },
      ],
    },
    { path: "Supervisors", children: requestRoutes(REQUEST_UNITS.area.key) },
    { path: "Engineering", children: requestRoutes(REQUEST_UNITS.engineering.key) },
  ],
};
